// extracted by mini-css-extract-plugin
export var horizontalStyle = "TimelineCards-module--horizontalStyle--0d4d4";
export var image = "TimelineCards-module--image--65a30";
export var number = "TimelineCards-module--number--b5569";
export var richtext = "TimelineCards-module--richtext--d621b";
export var section = "TimelineCards-module--section--8a0c6";
export var text = "TimelineCards-module--text--5e91d";
export var textWithMargin = "TimelineCards-module--textWithMargin--f9753";
export var wrapper = "TimelineCards-module--wrapper--82416";